import { GenericTestRouteState } from './generic-test-state'

export const LoboTestRouteState =
  GenericTestRouteState.named('LoboTestRouteState')
